import React from 'react';
import {Detail} from '../components';

const fp = () => (
  
  <div className="fp">
    <Detail count="2" hrenable="none" wordColors={[]}/>
      <Detail heading="<Future Plans>" hfsize="64px" hrmarl="485px" hrmarr="485px" spcolor="#F8C43F" wordColors={[{word:"Theoretical Mathematics",scolor:"#4E598C"},
      {word:"innovative project ideas",scolor:"#5F0A87"},
      {word:"Indian Statistical Institute",scolor:"#F5FFC6"}]} 
      description="<br><br><br>Numerates club has decided to bring some major changes in the group<br> in order to address the mathematical aspects of all the fields there in <br>the university. The club will be focusing on the technical as well as<br> non-technical aspects along with the Theoretical Mathematics.<br><br>

      The club will be promoting innovative project ideas along with proper<br> guidance with the help of industrialist and professors from the<br> university as well as outside the university. Further, workshops<br> regarding the skills which are in demand and those which will be the<br> future requirement.<br><br>
      
      We are practicing for LIMIT 2022 and mathematical competition hosted<br> by Indian Statistical Institute. We are planning for our next<br> recruitment on 23rd September. After collaborating with KPIT to<br> market their Sparkle Event in our college, now we are looking forward<br> to collaborate with Larsen & Toubro (L&T) for their competition<br> (named TECHgium).<br><br>"
      color="#fff"/>
       <Detail marginLeft="310px" marginRight="310px" hrmarl='50px' hrmarr='50px' spcolor="#C3D2D5" wordColors={[]}/>
    <Detail marginLeft="310px" marginRight="310px" hrmarl='150px' hrmarr='150px' spcolor="#C3D2D5" wordColors={[]}/>
        <Detail count="10" hrenable="none" wordColors={[]}/>
  </div>    
);

export default fp;
